<div class="timeline-container">
  <!-- Filtros da Timeline -->
  <div class="timeline-filters">
    <div class="filter-buttons">
      <p-button
        icon="pi pi-list"
        [severity]="isFilterActive('all') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('all')"
        size="small"
        (click)="setFilter('all')"
        title="Mostrar tudo" />
      <p-button
        icon="pi pi-comment"
        [severity]="isFilterActive('comments') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('comments')"
        size="small"
        (click)="setFilter('comments')"
        title="Apenas comentários" />
      <p-button
        icon="pi pi-globe"
        [severity]="isFilterActive('public') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('public')"
        size="small"
        (click)="setFilter('public')"
        title="Apenas públicos" />
      <p-button
        icon="pi pi-lock"
        [severity]="isFilterActive('private') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('private')"
        size="small"
        (click)="setFilter('private')"
        title="Apenas privados" />
      <p-button
        icon="pi pi-clock"
        [severity]="isFilterActive('timeentries') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('timeentries')"
        size="small"
        (click)="setFilter('timeentries')"
        title="Apenas apontamentos" />
      <p-button
        icon="pi pi-check-square"
        [severity]="isFilterActive('tasks') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('tasks')"
        size="small"
        (click)="setFilter('tasks')"
        title="Apenas tarefas" />
      <p-button
        icon="pi pi-paperclip"
        [severity]="isFilterActive('attachments') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('attachments')"
        size="small"
        (click)="setFilter('attachments')"
        title="Apenas anexos" />
      <p-button
        icon="pi pi-file"
        [severity]="isFilterActive('documentations') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('documentations')"
        size="small"
        (click)="setFilter('documentations')"
        title="Apenas documentações" />
      <p-button
        icon="pi pi-external-link"
        [severity]="isFilterActive('opened') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('opened')"
        size="small"
        (click)="setFilter('opened')"
        title="Apenas aberturas" />
      <p-button
        icon="pi pi-pencil"
        [severity]="isFilterActive('history') ? 'primary' : 'secondary'"
        [outlined]="!isFilterActive('history')"
        size="small"
        (click)="setFilter('history')"
        title="Apenas movimentações" />
    </div>

    <div class="timeline-view-mode-toggle">
      <p-button
        icon="bi bi-markdown"
        [severity]="timelineViewMode() === 'markdown' ? 'primary' : 'secondary'"
        [outlined]="timelineViewMode() !== 'markdown'"
        size="small"
        (click)="timelineViewMode() !== 'markdown' && toggleViewMode()"
        pTooltip="Markdown"
        tooltipPosition="bottom" />
      <p-button
        icon="bi bi-body-text"
        [severity]="timelineViewMode() === 'text' ? 'primary' : 'secondary'"
        [outlined]="timelineViewMode() !== 'text'"
        size="small"
        (click)="timelineViewMode() !== 'text' && toggleViewMode()"
        pTooltip="Texto simples"
        tooltipPosition="bottom" />
    </div>
  </div>

  <!-- Conteúdo da Timeline com rolagem -->
  <div class="timeline-content">
    @if (filteredEntries().length === 0) {
      <div class="timeline-empty">
        <i class="pi pi-clock" style="font-size: 2rem; color: var(--v-text-muted)"></i>
        <span>{{ emptyMessage() }}</span>
      </div>
    } @else {
      <p-timeline [value]="filteredEntries()" align="left">
        <ng-template #marker let-entry>
          <span class="timeline-marker" [style.background-color]="entry.color">
            <i [class]="entry.icon" style="font-size: 0.75rem"></i>
          </span>
        </ng-template>

        <ng-template #content let-entry>
          <div
            class="timeline-entry"
            [class.entry-open]="entry.isOpen"
            [class.entry-highlighted]="isEntryHighlighted(entry)">
            <div class="timeline-entry-header">
              <span class="timeline-entry-type">{{ entry.title }}</span>
              @if (entry.type === 'comment') {
                @if (entry.isPublic) {
                  <i class="pi pi-globe public-indicator" pTooltip="Comentário Público"></i>
                } @else {
                  <i class="pi pi-lock private-indicator" pTooltip="Comentário Privado"></i>
                }
              }
              <span class="timeline-entry-date">{{ formatDate(entry.date) }}</span>
            </div>
            @if (entry.type === 'log') {
              <div class="timeline-entry-times">
                <span class="time-range">
                  <i class="pi pi-play" style="font-size: 0.5625rem"></i>
                  {{ formatTime(entry.startDate) }}
                </span>
                @if (entry.endDate) {
                  <span class="time-range">
                    <i class="pi pi-stop" style="font-size: 0.5625rem"></i>
                    {{ formatTime(entry.endDate) }}
                  </span>
                  <span class="time-duration">{{
                    calcDuration(entry.startDate, entry.endDate)
                  }}</span>
                } @else {
                  <span class="time-open-badge">Em andamento</span>
                }
              </div>
            }
            @if (entry.type === 'task') {
              <div class="timeline-entry-task">
                @if (entry.data && entry.data['finished']) {
                  <span class="task-completed-badge">
                    <i class="pi pi-check"></i>
                    Concluída
                  </span>
                } @else {
                  <span class="task-pending-badge">
                    <i class="pi pi-clock"></i>
                    Pendente
                  </span>
                }
              </div>
            }
            @if (entry.type === 'attachment') {
              @if (
                entry.data &&
                entry.data['link_file'] &&
                isImageUrl(getFileNameFromUrl(entry.data['link_file']))
              ) {
                <div class="timeline-entry-attachment">
                  @if (entry.description) {
                    <div class="timeline-entry-body">{{ entry.description }}</div>
                  }
                  <div class="timeline-entry-images mt-2">
                    <div
                      class="timeline-image-thumbnail cursor-pointer transition-all transition-duration-200 hover:shadow-lg relative"
                      (click)="downloadAttachment(entry.data, entry.description)"
                      [title]="getFileNameFromUrl(entry.data['link_file'])">
                      <img
                        [src]="getAttachmentImageUrl(entry.data)"
                        [alt]="getFileNameFromUrl(entry.data['link_file'])"
                        class="thumbnail-img"
                        (load)="loadAttachmentImageBlob(entry.data, $event.target)"
                        (error)="
                          $event.target.src =
                            'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2260%22 height=%2260%22%3E%3Crect fill=%22%23f3f4f6%22 width=%2260%22 height=%2260%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 text-anchor=%22middle%22 dy=%22.3em%22 font-size=%2212%22 fill=%22%239ca3af%22%3E?%3C/text%3E%3C/svg%3E'
                        " />
                      <p-button
                        icon="pi pi-link"
                        severity="secondary"
                        size="small"
                        pTooltip="Copiar link do anexo"
                        tooltipPosition="top"
                        styleClass="absolute top-0 left-0 w-2rem h-2rem p-0"
                        (onClick)="copyAttachmentLink(entry.data, $event)" />
                    </div>
                  </div>
                </div>
              } @else {
                <div class="timeline-entry-attachment">
                  <div class="flex align-items-center gap-1">
                    <span
                      class="attachment-info"
                      (click)="downloadAttachment(entry.data, entry.description)"
                      [title]="entry.description || getFileNameFromUrl(entry.data?.link_file)">
                      <i class="pi pi-paperclip"></i>
                      <span class="attachment-name">{{
                        getFileNameFromUrl(entry.data?.link_file)
                      }}</span>
                    </span>
                    <p-button
                      icon="pi pi-link"
                      severity="secondary"
                      [text]="true"
                      size="small"
                      pTooltip="Copiar link do anexo"
                      tooltipPosition="top"
                      styleClass="w-2rem h-2rem p-0 flex-shrink-0"
                      (onClick)="copyAttachmentLink(entry.data, $event)" />
                  </div>
                  @if (entry.description) {
                    <div class="timeline-entry-body mt-2">{{ entry.description }}</div>
                  }
                </div>
              }
            }
            @if (entry.type === 'documentation') {
              <div class="timeline-entry-documentation">
                <span
                  class="documentation-badge"
                  (click)="openDocumentation(entry.data)"
                  [title]="entry.description">
                  <i class="pi pi-file"></i>
                  <span class="documentation-title">{{ entry.description }}</span>
                </span>
              </div>
            }
            @if (entry.type === 'opened') {
              <div class="timeline-entry-opened">
                <span class="opened-info">
                  <i class="pi pi-external-link"></i>
                  Chamado aberto
                </span>
              </div>
            }
            @if (entry.description && entry.type !== 'attachment') {
              <div class="timeline-entry-body">
                @if (timelineViewMode() === 'markdown') {
                  <markdown [data]="entry.description || ''"></markdown>
                } @else {
                  <pre class="timeline-text-plain">{{ entry.description }}</pre>
                }
              </div>
            }
            @if (
              entry.type === 'comment' &&
              entry.data &&
              entry.data['imageUrls'] &&
              entry.data['imageUrls'].length > 0
            ) {
              <div class="timeline-entry-images">
                @for (imageUrl of entry.data['imageUrls']; track imageUrl) {
                  <div
                    class="timeline-image-thumbnail cursor-pointer transition-all transition-duration-200 hover:shadow-lg"
                    (click)="openImagePreview(imageUrl, getFileNameFromUrl(imageUrl))"
                    [title]="getFileNameFromUrl(imageUrl)">
                    <img
                      [src]="imageUrl"
                      [alt]="getFileNameFromUrl(imageUrl)"
                      class="thumbnail-img"
                      (error)="
                        $event.target.src =
                          'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2260%22 height=%2260%22%3E%3Crect fill=%22%23f3f4f6%22 width=%2260%22 height=%2260%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 text-anchor=%22middle%22 dy=%22.3em%22 font-size=%2212%22 fill=%22%239ca3af%22%3E?%3C/text%3E%3C/svg%3E'
                      " />
                  </div>
                }
              </div>
            }
            @if (entry.user) {
              <div class="timeline-entry-user">
                <i class="pi pi-user" style="font-size: 0.625rem"></i>
                {{ entry.user }}
              </div>
            }
          </div>
        </ng-template>
      </p-timeline>
    }
  </div>
</div>

@if (previewVisible()) {
  <div class="ta-lightbox" (click)="closePreview()" role="dialog" aria-modal="true" aria-label="Visualizar imagem">

    <div class="ta-lightbox-title" (click)="$event.stopPropagation()">{{ previewName() }}</div>

    <button class="ta-lightbox-close" (click)="closePreview()" title="Fechar (Esc)">
      <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>

    <div
      class="ta-lightbox-wrap"
      [class.ta-can-pan]="zoomScale() > 1"
      [class.ta-panning]="dragging()"
      (click)="$event.stopPropagation()"
      (mousedown)="onDragStart($event)"
      (wheel)="onWheelZoom($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()">
      @if (previewLoading()) {
        <div class="ta-lightbox-loading">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
      } @else if (previewUrl()) {
        <img
          [src]="previewUrl()"
          [alt]="previewName()"
          class="ta-lightbox-img"
          [class.ta-dragging]="dragging()"
          [style.transform]="imageTransform()"
          draggable="false"
          (error)="onPreviewImageError()"
        />
      }
    </div>

    <div class="ta-lightbox-toolbar" (click)="$event.stopPropagation()">

      <button class="ta-toolbar-btn" (click)="zoomOut()" title="Diminuir zoom (-)">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M8 11h6"/>
        </svg>
        <span>Diminuir</span>
      </button>

      <button class="ta-toolbar-btn" (click)="zoomReset()" title="Tamanho original (0)">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
        </svg>
        <span>Original</span>
      </button>

      <button class="ta-toolbar-btn" (click)="zoomIn()" title="Ampliar zoom (+)">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M11 8v6M8 11h6"/>
        </svg>
        <span>Ampliar</span>
      </button>

      @if (!isInternalPreview()) {
        <div class="ta-toolbar-sep"></div>

        <button class="ta-toolbar-btn" (click)="openCurrentInNewTab()" title="Abrir em nova aba">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
            <path d="M15 3h6v6"/><path d="M10 14L21 3"/>
          </svg>
          <span>Abrir</span>
        </button>

        <button
          class="ta-toolbar-btn"
          [class.ta-copied]="copyLinkLabel() !== 'Copiar link'"
          (click)="copyCurrentLink()"
          title="Copiar link da imagem">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
            <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
          </svg>
          <span>{{ copyLinkLabel() }}</span>
        </button>
      }

    </div>
  </div>
}
